define(['angular'], function(angular) {

    /**
     * @class userService: Manage user rights and roles. userNetwork is coming directly from KYP
     * userNetwork web service (app/controlles/WS/UserNetworkWebServiceController.php).
     */
    function UserService($rootScope, $q, userBackendProvider, userNetworkService) {
        var self = this;

        /**
         * Check group membership of a user
         * @param  {Object}  user
         * @param  {String}  role
         * @return {Boolean}
         */
        self.isGroupMember = function isGroupMember(user, role) {
            return user ? user.role === role : false;
        };

        self.getPeopleList = function getPeopleList() {
            let people = [];
            if($rootScope.users && $rootScope.user){
                Object.keys($rootScope.users).forEach(function(userCategory) {
                    $rootScope.users[userCategory].map(function(person) {
                        person.user.role = person.user.uid !== $rootScope.user.uid ? userCategory.toUpperCase(): $rootScope.user.role;
                    });
                    people = people.concat($rootScope.users[userCategory]);
                });
                people = people.concat({ user: $rootScope.user });
            }

            return people;
        };

        /**
         * Look for a user object in rootScope.users with the given id
         * @param  {String} id
         * @return {Object}
         */
        self.findPerson = function findPerson(id) {
            return self.getPeopleList().find(function(person) {
                return person.user.uid === id;
            });
        };

        self.isExternalUser = function isExternaluser(user) {
            return self.isGroupMember(user, 'EXT') || self.isGroupMember(user, 'ANCIEN_RDS');
        };

        self.isSalesRep = function isSalesRep(user) {
            return (
                self.isGroupMember(user, 'RDS') ||
                self.isGroupMember(user, 'CUP') ||
                self.isGroupMember(user, 'TELEPRO') ||
                self.isGroupMember(user, 'CS') ||
                self.isGroupMember(user, 'CSD')
            );
        };

        self.isSalesAdmin = function isSalesAdmin(user) {
            return (
                self.isGroupMember(user, 'AC') ||
                self.isGroupMember(user, 'DC') ||
                self.isGroupMember(user, 'RESP TELEPRO') ||
                self.isGroupMember(user, 'DRV') ||
                self.isGroupMember(user, 'RESP CSD')
            );
        };

        self.isSalesAdminLite = function(user) {
            return (
                self.isGroupMember(user, 'AC') ||
                self.isGroupMember(user, 'DC') ||
                self.isGroupMember(user, 'RESP TELEPRO') ||
                self.isGroupMember(user, 'RESP CSD')
            );
        };

        self.isTeleproForm = function(user) {
            return ['TELEPRO', 'CS', 'RESP TELEPRO', 'RESP CSD', 'CSD', 'AC', 'DC'].indexOf(user.role) !== -1;
        }

        self.getUsers = function() {
            return userBackendProvider.getUsers().then(function(data) {
                return data;
            });
        };

        self.getSectors = function() {
            return userBackendProvider.getSectors().then(function(data) {
                return data;
            });
        };

        self.updateSector = function(sector) {
            return userBackendProvider.updateSector(sector.secteur, sector).then(function(data) {
                return data;
            });
        };

        self.getUsersByRole = function(role) {
            return userBackendProvider.getUsersByRole(role).then(function(data) {
                return data;
            });
        };

        self.createOrUpdateUser = function(user) {
            return userBackendProvider.createOrUpdateUser(user).then(function(res) {
                return res;
            });
        };

        self.logOutHelpline = function(){
            userBackendProvider.logOutHelpline();
        }

        self.initUserNetWork = function() {
            let d = $q.defer();
            userNetworkService.getUserNetwork().then(function(userNetwork) {
                $rootScope.user = userNetwork.user;
                $rootScope.user.parent = userNetwork.parent;
                $rootScope.user.role = userNetwork.role;

                $rootScope.userNetwork = userNetwork;
                $rootScope.users = {
                    rds: userNetwork.rds,
                    rdsBusiness: userNetwork.rdsBusiness,
                    drv: userNetwork.drv,
                    cs: userNetwork.cs,
                    telepro: userNetwork.telepro,
                    csd: userNetwork.csd,
                    cup: userNetwork.cup,
                    formerRDS: userNetwork.formerRDS,
                    others: userNetwork.others
                };
                d.resolve(userNetwork);
            }, d.reject.bind(d));

            return d.promise;
        };

        return self;
    }

    UserService.$inject = ['$rootScope', '$q', 'userBackend', 'userNetworkService'];

    angular.module('app.bdc.common.userService', []).factory('userService', UserService);
});
